/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import AutocompleteMaterial from '@mui/material/Autocomplete';
import { SxProps, TextField, Theme } from '@mui/material';
import '../../styles/components/select.scss';
import { ThemeLocale } from '../themeLocale';

/**
 * @param options - массив опшенов в выпадающем списке
 * @param placeholder - текст при невыбранном опшене в поле
 * @param label - надпись над полем ввода
 * @param required - булево на обязательное наличие значения
 * @param value - значение стейта, хранящее выбранный(ые) опшен
 * @param multiple - булево, отвечающее за возможность выбора нескольких
 * @param disabled - булево, отвечающее за доступность поля
 * @param filterSelectedOptions - если true, при выборе опшена, он не показывается в списке
 * @param onChange - функция, срабатывающая при выборе нового опшена
 * @param getOptionLabel - функция, принимает опшен и возвращает подсчитанное значение, отображаемое в списке и инпуте
 * @param getOptionId - функция, вовращает подсчитанное значение id
 */
interface AutocompleteProp<T> {
  options: T[];
  placeholder?: string;
  disabledClearable?: boolean;
  label?: string;
  required?: boolean;
  value: T | T[];
  multiple?: boolean;
  disabled?: boolean;
  filterSelectedOptions?: boolean;
  width?: number;
  height?: number;
  styles?: SxProps<Theme>;
  disableClearable?: boolean;
  onChange: (value: T | T[]) => void;
  getOptionLabel?: (option: Record<string, any> | string | number) => string;
  getOptionId?: (option: Record<string, any> | string | number) => string | number;
  className?: string;
}

export const Autocomplete = <T, >({
  options = [],
  placeholder,
  disableClearable,
  label,
  width,
  height,
  required,
  value,
  styles,
  filterSelectedOptions = false,
  disabled = false,
  multiple = false,
  onChange,
  getOptionLabel = (option) => (typeof option === 'object' && option ? option.name : option),
  getOptionId = (option) => (typeof option === 'object' && option ? option.id : option),
  className = '',
}: AutocompleteProp<T>) => {
  return (
    <ThemeLocale>
      <AutocompleteMaterial
        multiple={multiple}
        id="tags-standard"
        options={options}
        disableClearable={disableClearable}
        sx={{ width: width ?? "100%", height, ...styles }}
        value={value}
        filterSelectedOptions={filterSelectedOptions}
        disabled={disabled}
        renderTags={() => <></>}
        isOptionEqualToValue={(option: T, value: T) => getOptionId(option) === getOptionId(value)}
        onChange={(_event: React.SyntheticEvent, value: T | Array<T>) => onChange(value)}
        getOptionLabel={getOptionLabel}
        className={className}
        renderInput={(params) => (
          <TextField
            {...params}
            required={required}
            variant="outlined"
            size="small"
            sx={styles}
            label={label}
            placeholder={placeholder}
          />
        )}
      />
    </ThemeLocale>
  );
};
